import { render, staticRenderFns } from "./ask-organiser-form-v2.vue?vue&type=template&id=f687933c&"
import script from "./ask-organiser-form-v2.vue?vue&type=script&lang=ts&"
export * from "./ask-organiser-form-v2.vue?vue&type=script&lang=ts&"
import style0 from "./ask-organiser-form-v2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports